<template>
  <div id="app">
    <div style="
        display: flex;
        flex-direction: column; /* 添加这一行 */
        justify-content: center;
        align-items: center;
        height: 100vh;
        text-align: center;
      " v-if="isMobile">
      <!-- <h1>汇农服为农综合服务平台</h1> -->
      <h1>汇农服农业社会化服务平台</h1>
      <h2 style="margin-top: 60px;">扫码打开微信小程序</h2>
      <img src="../public/imgs/code-1.png" alt="" style="text-align: center; width: auto; height: auto;
        margin-bottom: 30px;" />
      <el-button type="success" round @click="openWeChatMiniProgram" style="margin-bottom: 50px;">打开微信小程序</el-button>
    </div>
    <div v-else>
      <!-- <meta name="viewport" content="width=device-width, initial-scale=1.0"> -->
      <el-dialog title="系统提示" width="30%" center :visible.sync="TipsShow" :before-close="handleClose">
        <div class="TipsBox" v-if="TipsList.length">

          <div class="approval-info">

            <div v-for="(group, index) in TipsList" :key="group.groupName" class="group-item">
              <p class="info-text">
                <span v-if="index == 0">您</span>{{ group.groupName }}
                <span v-for="(config, index) in group.approvalConfigList" :key="config.id">
                  在{{ config.areaName }}已流转{{ parseInt(config.totalArea) }}亩
                  <span v-if="index < group.approvalConfigList.length - 1">，</span>
                </span> <span v-if="group.approvalConfigList.length">，</span>


                <!-- <span class="info-text">
                  <span v-for="(doc, index) in group.approvalConfigList" :key="'doc-' + doc.articleContent">
                    <span v-if="doc.articleTitle" style="color: #40A3FF;">
                      《<a class="doc-link" @click="showDocument(doc.articleContent)">{{ doc.articleTitle }}</a>》

                    </span>

                  </span>
                </span> -->

              </p>

              <!-- <p class="info-text">
                    <span v-for="(doc, index) in group" :key="'doc-' + doc.articleContent">
                      《<a class="doc-link" @click="showDocument(doc.articleContent)">{{ doc.articleTitle }}</a>》
                      <span v-if="index < group.length - 1">、</span>
                    </span>
                    规定；
                  </p> -->
            </div>
            <!-- 统一显示去重后的文档 -->
            <p class="info-text">
              <span> 根据</span>
              <span v-for="(doc, index) in uniqueDocuments()" :key="'doc-' + doc.articleContent">
                《<a class="doc-link" @click="showDocument(doc.articleContent)">{{ doc.articleTitle }}</a>》
                <span v-if="index < uniqueDocuments().length - 1">、</span>
              </span>
              规定；
            </p>

            <p class="action-text">
              您需要将流转意向提交有关部门审批，请问是否现在提交审批？
            </p>
          </div>
          <div class="TipsBtn">
            <button class="closeBtn" @click="closeBtn">
              待流转计划完成后统一流转
            </button>
            <button class="ToPathBtn" @click="goToSubmit">去提交</button>
          </div>
        </div>
      </el-dialog>
      <!-- <div  v-if="userEqui=='pc'">
        <my-header />
      </div>
      <div style="height: 40px;" v-else>
        <my-header />
      </div> -->
      <my-header v-if="!hideHeader" />
      <router-view></router-view>
      <my-footer v-if="!hideFooter" />
    </div>
  </div>
</template>
<script>
  import myHeader from "./components/header/index";
  import myFooter from "./components/footer/index";
  import { mapGetters, mapState } from "vuex";
  import { selectPrompted } from "./api/websocket";
  import { getUserMenuByIdentity } from "@/api/add";

  export default {
    // metaInfo: {
    //   title: window.pageConfiguration.company.title,
    //   meta: [
    //     { name: "description", content:  window.pageConfiguration.company.description },
    //     { name: "keywords", content: window.pageConfiguration.company.keywords },
    //   ],
    // },
    components: {
      myHeader,
      myFooter,
    },
    data: () => ({
      TipsList: {},
      TipsShow: false,
      isMobile: false,
      baseUrl: window.globalUrl.BASE_API,
      userEqui: sessionStorage.getItem("equiType"), //设备类型 参数为web或pc
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
    }),
    watch: {
      $route(to, from) {
        // 当路由变化时调用接口
        console.log(to.path, "查看路由的监听");
        this.isTipsShow();
      },
    },
    mounted() { },
    created() {
      console.log(
        this.getUserEquiInfo()
      );
      // 根据设备类型进行判断
      // try {
      //   if (this.$device.ios && !this.$device.mac) {
      //     this.isMobile = true;
      //   } else if (this.$device.android) {
      //     this.isMobile = true;
      //   } else if (this.$device.windows) {
      //     this.isMobile = false;
      //   } else {
      //     this.isMobile = false; // 其他设备默认设置为非移动设备
      //   }
      // } catch (error) {
      //   console.log("检测设备类型时发生错误: ", error);
      //   this.isMobile = false; // 出现错误时默认设置为非移动设备
      // }

      // this.selectPrompted()
      // this.TipsShow=this.SetTipsShow
      // 登录
      //  console.log(!this.foreverNoShow,'查看这里的值1122221')
    },
    computed: {
      ...mapGetters(["identityObj", "vipLeftTree", "userInfo"]),
      ...mapState(["isPhone"]),
      hideHeader(){
        return this.$route.meta?.hideHeader
      },
      hideFooter(){
        return this.$route.meta?.hideFooter
      }
    },

    methods: {
      //获取用户设备是移动端还是PC端
      getUserEquiInfo() {
        // ua 判断是否在小程序 WebView 中
        const ua = window.navigator.userAgent.toLowerCase();
        // 判断是否在小程序 WebView 中
        const isWechatMiniProgram = /miniprogram/.test(ua) && /micromessenger/.test(ua);
  
        // 判断设备类型
        const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua);
        console.log(isMobile, 'isMobile');
        console.log(isWechatMiniProgram, 'isWechatMiniProgram');

        this.$store.commit('setIsPhone', isWechatMiniProgram || isMobile)

        const equiType = isMobile ? 'web' : 'pc';
        sessionStorage.setItem("equiType", equiType); //缓存用户设备类型 参数为web或pc
        sessionStorage.setItem("equiWidth", window.innerWidth);//缓存用户设备宽度用于适配移动端
      },
      openWeChatMiniProgram() {
        // 替换为你的小程序的 appId 和页面路径
        const miniProgramUrl = 'weixin://dl/business?appid=wx1b4a19d2537a3306&path=pages/index/index';
        location.href = miniProgramUrl;
      },

      // // 全局去重：收集所有文档并去重
      uniqueDocuments() {
        const allDocs = [];
        const contentMap = {};

        this.TipsList.forEach((group) => {
          group.approvalConfigList.forEach((config) => {
            if (!contentMap[config.articleContent]) {
              contentMap[config.articleContent] = true;
              allDocs.push({
                articleTitle: config.articleTitle,
                articleContent: config.articleContent,
              });
            }
          });
        });
        console.log(allDocs, '查看allDocs')

        return allDocs;
      },

      //系统提示调用接口
      isTipsShow() {
        // if (this.identityObj.identityTypeCode) {
        //   //判断是否此登录期间都不显示

        //   let hasShowTip = sessionStorage.getItem("hasShowTip");
        //   let isUrl = sessionStorage.getItem("isUrl");
        //   if (isUrl) {
        //     sessionStorage.setItem("hasShowTip", "");
        //   }
        //   if (!hasShowTip) {
        //     this.selectPrompted(); //系统提示
        //     //  localStorage.setItem("hasShowTip",true)
        //   }
        // }
        if(this.identityObj.identityTypeCode){
           this.selectPrompted(); //系统提示
        }
      },
      //跳转政策法规

      showDocument(articleContent) {
        window.open(window.location.origin + "#/home/news?c=" + articleContent, "_blank")
        // window.open(
        //   `${this.baseUrl}#/home/news?c=${articleContent}`,
        //   "_blank"
        // ); // 在新窗口中打开链接
        //  window.open('http://localhost:8086/#/home/news?c=1f7c8e8b8aeb67cd5fb69f256c0d630d', '_blank'); // 在新窗口中打开链接
        //  window.open('http://localhost:8086/#/home/news?c=9f17009d69a5a360cb2ce048c9ccb7ab', '_blank'); // 在新窗口中打开链接
        // this.$router.push({ name: "newsPage", query: { c: this.TipsList.articleContent } });
        // this.SET_TOROUTER(true)

        sessionStorage.setItem("hasShowTip", true);
        sessionStorage.setItem("isUrl", true);
      },
      //系统提示
      async selectPrompted() {
        let res = await selectPrompted();

        if (res.code == 0) {
           this.TipsList = res.data ? res.data : []
          this.TipsShow = this.TipsList.length ? true : false;
        }
      },
      //去重
      // processTipsList(data) {
      //   const seen = new Set(); // 全局记录已存在的 articleContent
      //   return data.map(group => ({
      //     ...group,
      //     approvalConfigList: group.approvalConfigList.map(item => {
      //       const isDuplicate = seen.has(item.articleContent);
      //       if (!isDuplicate) seen.add(item.articleContent); // 首次出现时记录
      //       return isDuplicate
      //         ? { ...item, articleTitle: "" }  // 重复项清空标题
      //         : item;                         // 非重复项保持原样
      //     })
      //   }));
      // },
      handleClose() {
        this.TipsShow = false;
        sessionStorage.setItem("hasShowTip", true);
      },
      closeBtn() {
        this.TipsShow = false;
        sessionStorage.setItem("hasShowTip", true);
      },
      goToSubmit() {
        this.TipsShow = false;
        sessionStorage.setItem("hasShowTip", true);

        this.toPath();
      },
      //跳转的菜单
      toPath() {
        // 会员中心
        let arr = this.vipLeftTree;
        console.log("arr", arr);
        if (!this.userInfo.identityList) {
          this.$router.push({ name: "login" });
        } else {
          if (this.identityObj.identityName && arr.length == 0) {
            this.getOthersInfo();
          }
          console.log(arr, "查看arr");
          if (arr.length > 0) {
            if (arr[1].children.length == 0) {
              this.$router.push({
                path: arr[1].allPath,
              });
            } else {
              if (arr[1].children.length > 0) {
                this.$router.push({
                  path: arr[1].children[3].allPath,
                });
              }
            }
          }
        }
      },
      async getOthersInfo() {
        try {
          let res = await getUserMenuByIdentity();
          // console.log("121241456", res);
          if (res.code == 0 && res.data.menuList.length > 0) {
            res.data.menuList.forEach((item) => {
              if (item.path === "memberCenter") {
                let arr = this.transMenu([item][0].children, "/memberCenter");
                console.log("1", arr);
                if (arr.length > 0) {
                  this.setVipTree(arr);
                  this.$router.$avueRouter.formatRoutes(arr, true);
                  if (arr[0].children.length == 0) {
                    this.$router.push({
                      path: arr[0].allPath,
                    });
                  } else {
                    if (arr[0].children.length > 0) {
                      this.$router.push({
                        path: arr[0].children[0].allPath,
                      });
                    }
                  }
                }
              }
            });
          }
        } catch (error) {
          // console.log("错误", error);
        }
      },
    },
  };
</script>
<style lang="less">
  .TipsBox {
    width: 100%;
    height: auto;
    /* 高度可以根据内容自动调整 */
    font-size: 16px;
    /* 基本的字体大小适用于 PC */
    display: flex;
    flex-direction: column;

    .TipsBtn {
      display: flex;
      margin-top: 50px;
      justify-content: space-between;

      .closeBtn {
        padding: 15px, 10px;
        font-size: 23px;
        background: #d6d6d6;
        color: white;
        border-radius: 5px;
        border: none;
      }

      .ToPathBtn {
        padding: 15px, 10px;
        font-size: 23px;
        background: #0a9f1a;
        color: white;
        border-radius: 5px;
        border: none;
      }
    }
  }

  .el-dialog__header {
    background-color: white !important;
  }

  /* 弹窗 */
  .approval-info {
    line-height: 1.6;
    padding: 20px;
  }

  .group-item {
    margin-bottom: 15px;
  }

  .doc-link {
    color: #1890ff;
    cursor: pointer;
    text-decoration: none;
  }

  .doc-link:hover {
    text-decoration: underline;
  }

  .action-text {
    margin-top: 20px;
    font-weight: bold;
  }

  .submit-btn {
    margin-left: 15px;
    padding: 6px 15px;
    background: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .submit-btn:hover {
    background: #40a9ff;
  }
</style>
